import React, { useContext, memo } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import { AdContext } from '../context';
import { getAdService } from '.';
import { getAdContextCookie } from '../helpers/cookie';

const AdServiceContext = React.createContext();
AdServiceContext.displayName = 'AdServiceContext';
const AdServiceContextProvider = props => {
  const { market } = useContext(AppContext);
  const adContext = useContext(AdContext);

  const serviceName = getAdContextCookie().service || market.ads.service;
  const service = getAdService(serviceName);
  const config = market.ads[serviceName] || {};

  return adContext.active ? (
    <service.provider
      config={config}
      adContext={adContext}
      baseProvider={AdServiceContext.Provider}
    >
      {props.children}
    </service.provider>
  ) : (
    props.children
  );
};

const { element } = PropTypes;

AdServiceContextProvider.propTypes = {
  children: element.isRequired,
};

export default {
  Provider: memo(AdServiceContextProvider),
  Consumer: AdServiceContext.Consumer,
};
